module.exports = __webpack_public_path__ + "r-v3/img/menu_docshare_white.17f1f3e1.svg";